import { Component } from '@angular/core';
import { shareReplay } from 'rxjs';
import { LoaderService } from 'src/app/services/loader/loader.service';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
	isLoading$ = this.loaderService.loader$.pipe(shareReplay(1));

	constructor(private readonly loaderService: LoaderService) {}
}
